<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters pb-5">
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="2">
          <v-select solo :items="statusOptions" v-model="selectedStatus" append-icon="mdi-chevron-down"
            class="custom-select" item-text="text" item-value="value" label="Status" @change="handleSelectChange">
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="dateRange" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                readonly v-bind="attrs" v-on="on" solo class="custom-select" label="Date Range"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelSelection">Cancel</v-btn>
              <v-btn text @click="confirmSelection">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4">
          <ul>
            <li>
              <span class="text--green">Total Withdraws:</span>
              <span>{{ formattedAllNumber(filteredTotalDepositAmount) }}</span>
            </li>
            <li>
              <span>Items:</span>
              <span>{{ formattedAllNumber(filteredTotalDeposits) }}</span>
            </li>
            <li v-if="$canRoute('withdraw-reg-tab') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile elevation="0" class="text-capitalize" color="#039de9" v-bind="attrs" v-on="on">
                    <v-icon> mdi mdi-tray-arrow-down </v-icon>
                    Withdraw
                  </v-btn>
                </template>
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Withdraw
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Withdraw Money From Here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Trading Account*</legend>
                          <v-select v-model="formData.tradingAccount" solo :items="tradingAcc" item-text="text"
                            item-value="value" append-icon="mdi-chevron-down" label="Select Your Acc."
                            class="custom-select" hide-details @change="updateCurrencyName"></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Payment Method*</legend>
                          <v-select v-model="selectedPaymentMethod" solo :items="withdrawPaymentSystem" item-text="text"
                            item-value="value" append-icon="mdi-chevron-down" label="Select Method"
                            class="custom-select" hide-details></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" :cols="currency.name !== 'USD' ? 6 : 12">
                        <fieldset>
                          <legend>Amount*</legend>
                          <v-text-field v-model="formData.amount" label="Enter Amount" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="6" v-if="currency.name !== 'USD'">
                        <fieldset>
                          <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span>
                          </legend>
                          <v-text-field disabled :value="formData.amount * currency.rate" label="Enter Amount"
                            single-line solo hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Transaction ID*</legend>
                          <v-text-field v-model="formData.transactionId" label="Enter Transaction Id" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <div v-if="withdrawPaymentSystem?.find(method => method.value ===
                        selectedPaymentMethod)?.text === 'bank'" style="width: 100%;">
                        <v-col cols="12">
                          <fieldset>
                            <legend>Brokers Bank Name*</legend>
                            <v-select v-model="formData.bankName" solo :items="brokersbanks"
                              item-text="beneficiary_bank_name" item-value="beneficiary_bank_name"
                              append-icon="mdi-chevron-down" label="Select Bank Name" class="custom-select"
                              hide-details></v-select>
                          </fieldset>
                        </v-col>
                        <v-col cols="12">
                          <fieldset>
                            <legend>Brokers Bank Account Number</legend>
                            <v-text-field v-model="formData.bank_account_no"
                              :label="brokersbanks.find(item => item.beneficiary_bank_name === formData.bankName)?.beneficiary_account"
                              single-line solo hide-details disabled class="custom-select"></v-text-field>
                          </fieldset>
                        </v-col>
                      </div>
                      <!-- Dynamic fields based on payment method -->
                      <template v-for="field in getPaymentMethodFields()">
                        <v-col cols="12">
                          <fieldset>
                            <legend>{{ field.label }}</legend>
                            <v-text-field v-if="field.type !== 'select'" v-model="formData[field.name]"
                              :label="field.placeholder" single-line solo hide-details
                              class="custom-select"></v-text-field>
                            <v-select v-else v-model="formData[field.name]" :items="field.options"
                              :label="field.placeholder" solo hide-details class="custom-select"></v-select>
                          </fieldset>
                        </v-col>
                      </template>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Upload a Slip or Screenshot <span class="optional">(Optional)</span></legend>
                          <v-file-input ref="fileInput" v-model="bankSlip" label="Upload a Slip or Screenshot"
                            :accept="'.jpg,.jpeg,.png,.pdf'" solo hide-details class="custom-select" prepend-icon=""
                            @change="handleFileUpload">
                            <template v-slot:selection="{ text }">
                              <span>{{ text || 'Upload file' }}</span>
                            </template>
                          </v-file-input>
                        </fieldset>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click="submitForm" :loading="loading" :disabled="loading" elevation="0"
                          class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Confirm</v-btn>
                        <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
                          class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
        <v-data-table :headers="headers" :items-per-page="5" :items="clientwithdraws" :search="search"
          loading-text="Loading... Please wait">
          <template v-slot:item.reference="{ item }">
            {{ item?.reference || "N/A" }}
          </template>
          <template v-slot:item.trx_type="{ item }">
            <div class="d-flex align-items-center">
              <v-icon color="#B4C2D1" small :class="verifyIcon(item.trx_type)"></v-icon>
              <span>{{ item.trx_type }}</span>
            </div>
          </template>
          <template v-slot:item.trading_account_no="{ item }">
            {{ item?.trading_account_no }}
          </template>
          <template v-slot:item.account_email="{ item }">
            <v-tooltip top color="#000">
              <template v-slot:activator="{ on }">
                <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                  {{ obfuscateAnyEmail(item?.account?.email) }}
                  <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                    {{ copiedStates[item.id] ? "mdi-check" : "mdi-content-copy" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ item?.account?.email }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ formatDate(item?.created_at) }}
          </template>
          <template v-slot:item.payment_system="{ item }">
            {{ item?.payment_system?.method_name || "N/A" }}
          </template>
          <template v-slot:item.admin_name="{ item }">
            {{ item?.admin_name || "N/A" }}
          </template>
          <template v-slot:item.status="{ item }">
            <span :style="{ color: item.status === 0 ? '#fbbc04' : item.status === 1 ? '#2ef6c6' : '#ff0606' }">
              {{ item.status === 0 ? "Pending" : item.status === 1 ? "Approved" : "Rejected" }}
            </span>
          </template>
          <template v-slot:item.details="{ item }">
            <v-dialog transition="scale-transition" origin="center center" max-width="985px"
              v-model="detailsDialog[item?.id]" content-class="deposit-modal">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-items-center">
                  <div v-bind="attrs" v-on="on">
                    <v-icon color="#039de9" small @click="handleFile(item?.payment_slip)">
                      mdi-eye-outline
                    </v-icon>
                  </div>
                </div>
              </template>

              <template>
                <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                  <v-btn class="close-btn" icon dark @click="handleClose(item)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>

                  <v-card-title>
                    <div class="image-details">
                      <v-img width="110" v-if="item?.payment_system?.method_name == 'Bank Transfer'"
                        src="@/assets/payments/bank.png"></v-img>
                      <v-img width="120" v-else-if="item?.payment_system?.method_name == 'Crypto'"
                        src="@/assets/payments/crypto.png"></v-img>
                      <v-img width="120" v-else-if="item?.payment_system?.method_name == 'Google Pay'"
                        src="@/assets/payments/gPay.png"></v-img>
                      <v-img width="120" v-else-if="item?.payment_system?.method_name == 'Debit/Credit Cards'"
                        src="@/assets/payments/mastercard.png"></v-img>
                      <v-img width="120" v-else src="@/assets/payments/cash.png"></v-img>
                      <h3>{{ item?.payment_system?.method_name }}</h3>
                    </div>
                    <div class="content-details">
                      <h3>Withdrawal:</h3>
                      <span>${{ item?.amount }}</span>
                    </div>
                  </v-card-title>
                  <div v-if="selectedFile">
                    <div class="img-center" v-if="isImage(item?.payment_slip)">
                      <img :src="item.payment_slip" class="modal-img"></img>
                    </div>
                    <div v-else-if="isPDF(item?.payment_slip)">
                      <iframe :src="item.payment_slip" width="100%" class="modal-iframe" height="250px"
                        frameborder="0"></iframe>
                    </div>
                    <div v-else>
                      <p class="text-center">Unsupported file format.</p>
                    </div>
                  </div>
                  <div v-else>
                    <p class="text-center">
                      No document preview available.
                    </p>
                  </div>
                  <v-card-subtitle v-if="selectedFile">
                    <div class="download-icon cursor-pointer" @click="downloadFile(item?.payment_slip)">
                      <p>Download</p>
                      <v-icon small slot="append" color="#039de9">
                        mdi-tray-arrow-down
                      </v-icon>
                    </div>
                    <div class="tab-details cursor-pointer" @click="openInNewTab(item?.payment_slip)">
                      <p>Open In New Tab</p>
                      <v-icon small slot="append" color="#039de9">mdi-eye</v-icon>
                    </div>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <h1>All Information</h1>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Name</legend>
                          <v-text-field :value="item?.account_fullname" readonly single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Email</legend>
                          <v-text-field readonly :value="item?.account_email || 'N/A'" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Account No</legend>
                          <v-text-field readonly :value="item?.trading_account_no" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Transaction Method</legend>
                          <v-text-field readonly :value="item?.payment_system?.method_name" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Transaction ID</legend>
                          <v-text-field readonly :value="item?.transaction_id || 'N/A'" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Amount</legend>
                          <v-text-field readonly :value="item?.amount" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Trx. Fee</legend>
                          <v-text-field readonly :value="item?.trx_fee" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Net Amount</legend>
                          <v-text-field readonly :value="item?.net_amount" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Reference No.</legend>
                          <v-text-field readonly :value="item?.reference" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Time</legend>
                          <v-text-field readonly :value="item?.created_at" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>

                      <v-col v-if="item?.bank_name" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank name</legend>
                          <v-text-field readonly :value="item?.bank_name" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col v-if="item?.bank_account_no" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank Account No.</legend>
                          <v-text-field readonly :value="item?.bank_account_no" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col v-if="item?.bank_iban" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank IBAN</legend>
                          <v-text-field readonly :value="item?.bank_iban" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col v-if="item?.bank_swift_code" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Bank Swift Code</legend>
                          <v-text-field readonly :value="item?.bank_swift_code" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col v-if="item?.ifsc_code" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>IFSC Code</legend>
                          <v-text-field readonly :value="item?.ifsc_code" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col v-if="item?.network" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Network</legend>
                          <v-text-field readonly :value="item?.network" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col v-if="item?.wallet_address" cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Crypto Address</legend>
                          <v-text-field readonly :value="item?.wallet_address" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Verification Image</legend>
                          <v-text-field readonly :value="item?.payment_slip || 'N/A'" single-line solo hide-details
                            class="custom-select">
                            <v-icon small slot="append" color="#039de9" @click="downloadFile(item?.payment_slip)">
                              mdi-tray-arrow-down
                            </v-icon></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Status</legend>
                          <v-text-field readonly :value="item?.status === 0
                            ? 'Pending'
                            : item?.status === 1
                              ? 'Approved'
                              : 'Rejected'
                            " single-line solo hide-details class="custom-select">
                            <v-icon small slot="prepend" color="#FFC020">
                              mdi-star-outline
                            </v-icon></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <fieldset>
                          <legend>Remarks</legend>
                          <v-text-field readonly :value="item?.remarks" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>
                    <v-row v-if="item?.status === 0">
                          <v-col cols="12">
                            <h3 class="text-success">Upload A Pay Slip</h3>
                          </v-col>
                          <v-col cols="12">
                            <fieldset>
                              <legend>Proof</legend>
                              <v-file-input v-model="pay_slip" label="Choose file in needed (Max Size 2MB)" single-line
                                solo prepend-icon="mdi-file-image" class="custom-select"
                                @change="onFileChange"></v-file-input>
                            </fieldset>
                            <v-img v-if="previewUrl" class="img-logo-bank" :src="previewUrl"></v-img>
                            <span v-if="errors.pay_slip" class="error-message">{{ errors.pay_slip }}</span>
                          </v-col>
                        </v-row>

                        <v-row v-if="isItOpen(item)">
                          <v-col cols="6">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block color="greenMain"
                                  :loading="isApproving" :disabled="isApproving || item?.status === 1 || $canRoute('withdraw-reg-tab') !== 1"
                                  @click="handleWithdrawApprove(item)">
                                <v-progress-circular v-if="isApproving" indeterminate size="16" width="2" color="white"
                                  class="mr-2"></v-progress-circular>
                                {{ item?.status === 1 ? "Approved" : (isApproving ? "Approving..." : "Approve") }}
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block color="#FF567F"
                                :disabled="item?.status === 1 || isApproving || $canRoute('withdraw-reg-tab') !== 1"
                                @click="handleOpenRejected()">
                                Rejected
                            </v-btn>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row v-if="item?.status === 2 || showRejectionCauseSection">
                          <v-col cols="12">
                            <h2>Rejection Cause</h2>
                          </v-col>
                          <v-col cols="12" v-if="item?.status !== 2">
                            <fieldset>
                              <legend>Reason</legend>
                              <v-select v-model="selectedReason" solo :items="slots5" append-icon="mdi-chevron-down"
                                label="Click to select" class="custom-select" hide-details></v-select>
                            </fieldset>
                          </v-col>
                          <v-col cols="12" v-if="
                            item?.status === 2 || selectedReason === 'Other'
                          ">
                            <fieldset>
                              <legend>
                                {{
                                  item?.status === 2
                                    ? "Reason"
                                    : "Write Your Reason"
                                }}
                              </legend>
                              <v-text-field :disabled="item?.status === 2" v-model="reason" single-line :label="item?.status === 2
                                ? item?.reason
                                : 'Write here'
                                " solo hide-details class="custom-select"></v-text-field>
                            </fieldset>
                          </v-col>
                          <v-col cols="6" v-if="item?.status !== 2">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block color="#FF567F"
                                :loading=isRejecting :disabled="isRejecting"
                                @click="handleWithdrawConfrimRejected(item)">
                                <v-progress-circular v-if="isRejecting" indeterminate size="16" width="2" color="white"
                                  class="mr-2"></v-progress-circular>
                                {{ isRejecting ? "Rejecting..." : "Confirm Reject" }}
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col cols="6" v-if="item?.status !== 2">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block outlined
                                class="ma-0 text-capitalize btn-account py-4" @click="handleCloseRejected()">
                                Cancel
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-dialog>
          </template>
        </v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import {
  PARTNERWITHDRAW__ACTIONS,
  REGISTERUSERDETAILS__ACTIONS,
  TRANSACTIONS__ACTIONS
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      errors: {
        pay_slip: ""
      },
      loading: false,
      search: "",
      bankSlip: null,
      selectedDates: [],
      pay_slip: null,
      previewUrl: null,
      isApproving: false,
      isRejecting: false,
      selectedDatesText: null,
      selectedStatus: null,
      copiedStates: {},
      dateRange: [],
      modal: false,
      filteredWithdraws: [],
      slots: ["All", "Pending", "Approved", "Rejected"],
      updateslots: [
        { status: 0, statusText: "Pending" },
        { status: 1, statusText: "Approved" },
        { status: 2, statusText: "Rejected" },
      ],
      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "Acc no.", value: "trading_account_no" },
        { text: "Pay. Method", value: "payment_system" },
        { text: "Amount", value: "amount" },
        { text: "Action By", value: "admin_name" },
        { text: "Status", value: "status" },
        { text: "Details", value: "details" },
      ],
      statusOptions: [
        { text: 'All', value: null },
        { text: 'Pending', value: 0 },
        { text: 'Approved', value: 1 },
        { text: 'Rejected', value: 2 },
      ],
      slots1: [], // Add your payment method options here
      slots2: [], // Add your trading account options here
      userId: null,
      dialogDeposit: false,
      selectedPaymentMethod: null,
      currency: {
        name: 'USD',
        rate: 1,
        color: '#fff'
      },
      formData: {
        tradingAccount: null,
        amount: null,
        transactionId: null,
        bankName: null,
        beneficiary_bank_name: null,
        bank_account_no: null,
        payment_slip: null,
      },
      isApproving: false,
      isRejecting: false,
      showRejectionCauseSection: false,
      selectedFile: null,
      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,
      detailsDialog: {},
       slots5: [
        "Deposit and withdrawal method must be same",
        "Not enough balance",
        "Can't transfer funds to third party accounts",
        "Any fraudulent activity we must suspend the principal account until investigation of compliance",
        "Other",
      ],
    };
  },
  computed: {
    ...mapState("reguserdetails", ["clientwithdraws", "brokersbanks", "tradingAcc", "withdrawPaymentSystem"]),
    ...mapState("trxwithdrawal", [
      "withdrawal",
      "totalWithdrawalCount",
      "isLoading",
      "isUpdating",
      "paymentMethods",
      "totalWithdrawal",
      "pagination"
    ]),
    ...mapState("admins", ["loggedAdmin"]),

    selectedDatesText() {
      return this.dateRange.join(' ~ ');
    },
    filteredTotalDeposits() {
      return this.clientwithdraws.length;
    },
    filteredTotalDepositAmount() {
      return this.clientwithdraws.reduce((total, deposit) => total + deposit.amount, 0);
    },
     isItOpen() {
      return function (item) {
        return item?.status == 0;
      };
    },
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.BROKERSBANK, 
    REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS, 
    REGISTERUSERDETAILS__ACTIONS.PAYMENTSYSTEMFORWITHDRAW, REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS, 
    REGISTERUSERDETAILS__ACTIONS.CREATECLIENTWITHDRAW]),
    ...mapActions("trxwithdrawal", [
      TRANSACTIONS__ACTIONS.TRXWITHDRAWAL,
      TRANSACTIONS__ACTIONS.UPDATEDEPOSIT,
    ]),
    ...mapActions("partnerwithdraw", [PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW]),
    ...mapActions("trxdeposit", [TRANSACTIONS__ACTIONS.UPDATEDEPOSIT]),
    onFileChange(file) {
      if (file && file.size < 2000000) {
        this.pay_slip = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.pay_slip = null;
        this.previewUrl = null;
        this.errors.pay_slip = "File size should be less than 2MB";
      }
    },
    verifyIcon(trx_type) {
      const lowerType = trx_type.toLowerCase();
      if (lowerType.startsWith("d")) return "mdi mdi-tray-arrow-down mr-1";
      if (lowerType.startsWith("w")) return "mdi mdi-tray-arrow-up mr-1";
      return "mdi mdi-repeat mr-1";
    },

    downloadFile(fileUrl) {
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = true;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    isImage(url) {
      return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);
    },

    isPDF(url) {
      return /\.pdf$/i.test(url);
    },

    openInNewTab(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    handleFile(item) {
      this.selectedFile = item;
      this.pay_slip = null;
      this.previewUrl = null;
    },

    async handleWithdrawApprove(item) {
    try {
      this.isApproving = true;
      const formData = new FormData();
      formData.append("id", item?.id);
      formData.append("status", 1);
      formData.append("remarks", this.remarks || "N/A");
      if (this.pay_slip) formData.append("payment_slip", this.pay_slip);

      await this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](formData); 
      item.status = 1;
      item.remarks = this.remarks || "N/A";
      await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWAL](); 
    } catch (error) {
      console.error("Error:", error);
    } finally {
      this.isApproving = false;
    }
  },

     handleOpenRejected() {
      this.showRejectionCauseSection = true; 
      this.showButtons = false;
    },

    handleCloseRejected() {
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
    },

    async handleWithdrawConfrimRejected(item) {
      try {
        this.isRejecting = true;
        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 2);
        formData.append("reason", this.reason || this.selectedReason || "N/A");

        if (this.pay_slip) formData.append("payment_slip", this.pay_slip);

        await this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](formData); 
        item.status = 2;
        item.reason = this.reason || this.selectedReason || "N/A";
        this.showRejectionCauseSection = false;
        this.showButtons = true;
        await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWAL](); 
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isRejecting = false;
      }
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
      this.previewUrl = null;
      this.pay_slip = null;
    },

    allMethods() {
      return [{ id: "All", method_name: "All" }, ...this.paymentMethods];
    },

    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        country_id: this.selectedCountry,
        search: this.search,
        method_name: this.methodName === "All" ? null : this.methodName,
        status: this.selectedStatus === "All"
          ? null
          : this.selectedStatus === "Pending"
            ? "0"
            : this.selectedStatus === "Approved"
              ? 1
              : this.selectedStatus === "Rejected"
                ? 2
                : null
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWAL](parameter);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    methodFilter() {
      this.options.page = 1;
      this.fetchData();
    },

    onStatusChange() {
      this.page = 1;
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },

    


    updateCurrencyName(selectedAccount) {
      const account = this.tradingAcc.find(acc => acc.value === selectedAccount);
      this.currency.name = account ? account.currency_name : 'USD';
      this.currency.rate = account ? account.currency_rate : 1;
      this.currency.color = account ? account.currency_color : '#fff';
    },

    handleOpenRejected() {
      this.showRejectionCauseSection = true;
      this.showButtons = false;
    },

    handleFile(item) {
      this.selectedFile = item;
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
    },
    openInNewTab(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    downloadFile(fileUrl) {
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = true;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getPaymentMethodFields() {
      const selectedMethod = this.withdrawPaymentSystem.find(method => method.value === this.selectedPaymentMethod);
      if (!selectedMethod) return [];

      switch (selectedMethod.pretty_name) {
        case 'custom-withdraw': // Custom Deposit, Custom Withdraw
          return [
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'bank-transfer': // Bank Transfer
          return [
            { name: 'bankName', label: 'Bank Name', placeholder: 'Enter Bank Name', type: 'text' },
            { name: 'accountName', label: 'Account Name', placeholder: 'Enter Account Name', type: 'text' },
            { name: 'bank_account_no', label: 'Bank Account No', placeholder: 'Enter Bank Account No', type: 'text' },
            { name: 'iban', label: 'IBAN', placeholder: 'Enter IBAN', type: 'text' },
            { name: 'swiftCode', label: 'SWIFT Code', placeholder: 'Enter SWIFT Code', type: 'text' },
            { name: 'ifsc_code', label: 'IFSC Code', placeholder: 'Enter IFSC Code', type: 'text' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'debit-credit-cards': // Debit/Credit Cards
          return [
            { name: 'cardNumber', label: 'Card Number', placeholder: 'Enter Card Number', type: 'text' },
            { name: 'expiryDate', label: 'Expiry Date', placeholder: 'MM/YY', type: 'text' },
            { name: 'cvv', label: 'CVV', placeholder: 'Enter CVV', type: 'text' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'neteller': // Neteller, Skrill
          return [
            { name: 'email', label: 'Email', placeholder: 'Enter Email', type: 'email' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'skrill': // Neteller, Skrill
          return [
            { name: 'email', label: 'Email', placeholder: 'Enter Email', type: 'email' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'crypto-transfer': // Crypto, Internal Transfer
          return [
            { name: 'walletAddress', label: 'Wallet Address', placeholder: 'Enter Wallet Address', type: 'text' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        default:
          return [
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
      }
    },

    resetFormData() {
      this.formData = {
        tradingAccount: null,
        amount: null,
        transactionId: null,
        bankName: null,
        bank_account_no: null,
        payment_slip: null,
      };
      // Clear any custom fields
      this.$refs.fileInput.value = '';
      this.bankSlip = null;
      const customFields = this.getPaymentMethodFields();
      customFields.forEach(field => {
        this.$set(this.formData, field.name, '');
      });
    },

    async handleFileUpload(file) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/webp', 'application/pdf'];
      const maxSize = 4 * 1024 * 1024; // 4MB+


      if (!file) return;

      if (!allowedTypes.includes(file.type)) {
        toast.error('Invalid file type. Please upload PNG, JPEG, WEBP, or PDF');
        this.bankSlip = null;
        this.$refs.fileInput.value = '';
        return;
      }

      if (file.size > maxSize) {
        toast.error('File size must be less than 4MB');
        this.bankSlip = null;
        this.$refs.fileInput.value = '';
        return;
      }

      this.formData.payment_slip = this.bankSlip;
    },

    async submitForm() {
      this.loading = true;
      try {
        const formData = new FormData();

        formData.append('amount', this.formData.amount);
        formData.append('tradingAccount', this.formData.tradingAccount);
        formData.append('transactionId', this.formData.transactionId);
        formData.append('paymentMethodId', this.selectedPaymentMethod);
        formData.append('client_account_id', this.userId);
        formData.append('payment_slip', this.bankSlip);

        if (this.formData.beneficiary_bank_name) {
          formData.append('beneficiary_bank_name', this.formData.beneficiary_bank_name);
          const bankAccount = this.brokersbanks.find(
            item => item.beneficiary_bank_name === this.formData.beneficiary_bank_name
          )?.beneficiary_account;
          if (bankAccount) {
            formData.append('bank_account_no', bankAccount);
          }
        }

        const additionalFields = this.getPaymentMethodFields();
        additionalFields.forEach(field => {
          if (this.formData[field.name]) {
            formData.append(field.name, this.formData[field.name]);
          }
        });

        await this[REGISTERUSERDETAILS__ACTIONS.CREATECLIENTWITHDRAW](formData)
        await this[REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS]({ client_account_id: this.userId })

        this.resetFormData();
        this.selectedPaymentMethod = null
      } catch (error) {
        console.error('Form submission error:', error);
      } finally {
        this.loading = false;
        this.dialogDeposit = false;
      }
    },

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    copyText(item) {
      navigator.clipboard.writeText(item?.account?.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email);
    },

    onUpdateChange(item) {
      let parameter = {
        id: item?.id,
        status: item.status,
      };
      this[TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](parameter);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('en-GB');
    },

    openDepositDetails(item) {
      console.log("Opening details for deposit:", item);
    },

    handleSelectChange() {
      const parameter = {
        status: this.selectedStatus,
        client_account_id: this.userId,
      };
      this[REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS](parameter);
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        client_account_id: this.userId,
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
      };

      this[REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
  },
  
  async created() {
    await this.fetchData();
  },

  mounted() {
    this.userId = this.$route.params.id
    this[REGISTERUSERDETAILS__ACTIONS.BROKERSBANK]();
    this[REGISTERUSERDETAILS__ACTIONS.PAYMENTSYSTEMFORWITHDRAW]();
    this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](this.$route.params.id);
    this[REGISTERUSERDETAILS__ACTIONS.CLIENTWITHDRAWS]({ client_account_id: this.$route.params.id });
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>

<style>
.align-items-center {
  justify-content: center;
}
</style>